export default __webpack_public_path__ + "static/media/gym-img-26.200005f9.jpg";